import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const IconClose = () => {
    return (
        <svg
            fill='none'
            style={{ width: '18px', height: '18px' }}
            viewBox='0 0 18 18'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M16.9706 0.000140667L0 16.9707L0.954594 17.9253L17.9252 0.954735L16.9706 0.000140667Z'
                fill='black'/>
            <path
                d='M17.9623 17.0082L0.991699 0.0375977L0.0371048 0.992192L17.0077 17.9628L17.9623 17.0082Z'
                fill='black'/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {};

IconClose.propTypes = propTypes;

export default IconClose;
